var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9.05823 3.86924C9.07898 3.57976 8.84973 3.3335 8.55951 3.3335H7.46288C7.17347 3.3335 6.94451 3.57845 6.96401 3.8672L7.30179 8.8672C7.31952 9.12966 7.53759 9.3335 7.80066 9.3335H8.20118C8.46345 9.3335 8.68115 9.13084 8.6999 8.86924L9.05823 3.86924ZM7.2592 13.1088C7.47847 13.2553 7.73625 13.3335 7.99996 13.3335C8.35358 13.3335 8.69272 13.193 8.94277 12.943C9.19282 12.6929 9.33329 12.3538 9.33329 12.0002C9.33329 11.7365 9.25509 11.4787 9.10859 11.2594C8.96208 11.0401 8.75384 10.8692 8.5102 10.7683C8.26657 10.6674 7.99848 10.641 7.73984 10.6924C7.4812 10.7439 7.24362 10.8709 7.05715 11.0574C6.87068 11.2438 6.74369 11.4814 6.69225 11.74C6.6408 11.9987 6.6672 12.2668 6.76812 12.5104C6.86904 12.754 7.03993 12.9623 7.2592 13.1088Z",
    fill: "#F23232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.028257ad31be1abb8ae08e779ee1ed12.svg";
export { ForwardRef as ReactComponent };